<template>
  <div class="application mt-5 mb-5">
  <b-container>
    <h2 class="section-heading mb-5">Recruitment Portal</h2>
    <div class="holding shadow">
      <p  v-if="!$route.query.complete">We have received your application and there is currently nothing left for you to do.</p>
      <p v-if="$route.query && $route.query.complete">We have received your details and there is currently nothing left for you to do.</p>
      <p v-if="!$route.query.complete">Keep an eye on your email for details regarding the next step in the recruitment process.</p>
      <p>Thank You, you will now be logged out.</p>
    </div>
  </b-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  mounted () {
    localStorage.clear()
    setTimeout(() => {
      this.logoutAction()
    }, 15000)
  },
  methods: {
    ...mapActions({
      logoutAction: 'authStore/logoutAction'
    })
  }
}
</script>

<style scoped>
.holding {
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px;
}
</style>
